import { load } from "@cashfreepayments/cashfree-js";
import { useEffect, useState, useCallback } from "react";
import { Container, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function Checkout() {
  const [cashfree, setCashfree] = useState(null);
  const { state } = useLocation();
  const orderState = useSelector((state) => state?.orderState);
  console.log("order-confirm", orderState);
  const paymentSessionId = state?.paymentSessionId; // Extract payment session ID
  
  useEffect(() => {
    const initializeSDK = async () => {
      const instance = await load({ mode: "production" });
      // const instance = await load({ mode: "sandbox" });
      setCashfree(instance);
    };
    initializeSDK();
  }, []);

  const doPayment = useCallback(async () => {
    if (!cashfree || !paymentSessionId) return;

    console.log("Session_ID", paymentSessionId);
    let checkoutOptions = {
      paymentSessionId: paymentSessionId,
      redirectTarget: "_self",
    };

    cashfree.checkout(checkoutOptions);
  }, [cashfree, paymentSessionId]);

  useEffect(() => {
    if (cashfree && paymentSessionId) {
      doPayment();
    }
  }, [cashfree, paymentSessionId, doPayment]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 4, borderRadius: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Redirecting to Payment checkout...
        </Typography>
      </Paper>
    </Container>
  );
}

export default Checkout;
